import {LeadEventTypeEnum} from "./LeadEvent";

export enum LeadEventCategory {
	Contact = "Contact",
	Status = "Status",
	Notes = "Notes",
	Reminders = "Reminders",
	Appointments = "Appointments",
	Surveys = "Surveys",
	Files = "Files",
	Quotes = "Quotes",
	Updates = "Lead Updates"
}

/**
 * Lead event type object model.
 */
export default class LeadEventTypeObject {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to LeadEventTypeObject.
	 * @param {string} string
	 * @return {LeadEventTypeObject}
	 */
	public static fromString(string: string): LeadEventTypeObject {
		return new LeadEventTypeObject(string)
	}

	/**
	 * Get LeadEventTypeObjects for given category.
	 * @param {string} filter Category key.
	 * @return {LeadEventTypeObject[]} List of LeadEventTypeObjects for given category.
	 */
	public static getTypesForCategory(filter: string): LeadEventTypeObject[] {
		if (filter === LeadEventCategory.Contact) {
			return LeadEventTypeObject.getContactTypes();
		}
		if (filter === LeadEventCategory.Status) {
			return LeadEventTypeObject.getStatusTypes();
		}
		if (filter === LeadEventCategory.Appointments) {
			return LeadEventTypeObject.getAppointmentsTypes();
		}
		if (filter === LeadEventCategory.Surveys) {
			return LeadEventTypeObject.getSurveysTypes();
		}
		if (filter === LeadEventCategory.Files) {
			return LeadEventTypeObject.getFilesTypes();
		}
		if (filter === LeadEventCategory.Quotes) {
			return LeadEventTypeObject.getQuotesTypes();
		}
		if (filter === LeadEventCategory.Updates) {
			return LeadEventTypeObject.getUpdatesTypes();
		}

		if (filter === LeadEventCategory.Notes) {
			return LeadEventTypeObject.getNotesTypes();
		}
		if (filter === LeadEventCategory.Reminders) {
			return LeadEventTypeObject.getRemindersTypes();
		}
		return [];
	}

	public static getContactTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.SmsSent),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.IncomingSms),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.EmailSent),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.ExternalCallRegistered),
		];
	}

	public static getStatusTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.StatusChanged),
		];
	}

	public static getNotesTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.Note),
		];
	}

	public static getRemindersTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.NoteReminder),
		];
	}

	public static getAppointmentsTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.AppointmentCreated),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.AppointmentUpdated),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.AppointmentStatusChanged),
		];
	}

	public static getSurveysTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.SurveyFilesAttached),
		];
	}

	public static getFilesTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.LeadFilesAttached),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.LeadFilesDeleted),
		];
	}

	public static getQuotesTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.QuoteFilesAttached),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.QuoteCommentCreated),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.QuoteStatusChanged),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.QuoteDeleted),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.QuoteRestored),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.QuoteFinanceProductChanged),
		];
	}

	public static getUpdatesTypes(): LeadEventTypeObject[] {
		return [
			LeadEventTypeObject.fromString(LeadEventTypeEnum.Created),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.Updated),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.AssigneesChanged),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.BdpAssigneeChanged),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.AgentAssigneeChanged),
			LeadEventTypeObject.fromString(LeadEventTypeEnum.WatchersChanged),
		];
	}
}
